// Mock data for Dein Gutachten Direkt - Enterprise Version

export const COMPANY_INFO = {
  name: "Dein Gutachten Direkt",
  slogan: "Verlässlich. Kompetent. Präzise.",
  phone: "0410 18471160",
  whatsapp: "4941018471160",
  location: "Rellingen",
  // Adresse nur für Schema Markup - NICHT auf Website anzeigen
  address: {
    street: "Möwenstraße 2",
    zip: "25462",
    city: "Rellingen",
    state: "Schleswig-Holstein",
    country: "Deutschland"
  },
  email: "info@dein-gutachten-direkt.de"
};

export const NAV_LINKS = [
  { label: "Leistungen", href: "/unfallgutachten" },
  { label: "Bewertungen", href: "/bewertungen" },
  { label: "Kontakt", href: "/kontakt" },
  { label: "Partner", href: "/partner" }
];

export const TRUST_INDICATORS = [
  { label: "24/7 Erreichbar", icon: "clock" },
  { label: "Bundesweit", icon: "map" },
  { label: "Unabhängig", icon: "shield-check" },
  { label: "Top bewertet", icon: "star" }
];

export const BENEFITS = [
  {
    title: "Unabhängiges Gutachten",
    description: "Neutrale Bewertung durch erfahrene Sachverständige – ausschließlich Ihren Interessen verpflichtet.",
    icon: "scale"
  },
  {
    title: "Kostenübernahme möglich",
    description: "Bei unverschuldetem Unfall trägt in der Regel die Haftpflichtversicherung die Gutachterkosten.",
    icon: "shield"
  },
  {
    title: "Direkt vor Ort",
    description: "Wir kommen zu Ihnen – egal wo in Deutschland. Terminvergabe meist innerhalb von 24-48 Stunden.",
    icon: "map-pin"
  }
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Kontaktaufnahme",
    description: "Rufen Sie uns an oder schreiben Sie per WhatsApp. Wir beraten Sie unverbindlich."
  },
  {
    step: "02",
    title: "Terminvereinbarung",
    description: "Schnelle Terminvergabe vor Ort – meist innerhalb von 24-48 Stunden möglich."
  },
  {
    step: "03",
    title: "Begutachtung",
    description: "Professionelle Dokumentation aller Schäden durch unseren Sachverständigen."
  },
  {
    step: "04",
    title: "Gutachten erhalten",
    description: "Sie erhalten das fertige Gutachten zur Vorlage bei der Versicherung."
  }
];

export const VEHICLE_TYPES = [
  { name: "PKW", icon: "car" },
  { name: "Elektrofahrzeuge", icon: "battery-charging" },
  { name: "LKW", icon: "truck" },
  { name: "Busse", icon: "bus" },
  { name: "Motorräder", icon: "bike" },
  { name: "Fahrräder", icon: "bike" },
  { name: "Boote", icon: "ship" }
];

export const ACCIDENT_GUIDE = [
  {
    step: "1",
    title: "Unfallstelle sichern",
    description: "Warndreieck aufstellen, Warnweste anlegen, Unfallstelle absichern."
  },
  {
    step: "2",
    title: "Polizei informieren",
    description: "Bei Personenschäden oder Unklarheiten immer die Polizei rufen."
  },
  {
    step: "3",
    title: "Daten austauschen",
    description: "Namen, Anschriften, Versicherungsdaten und Kennzeichen notieren."
  },
  {
    step: "4",
    title: "Fotos machen",
    description: "Unfallstelle, Schäden und Position der Fahrzeuge dokumentieren."
  },
  {
    step: "5",
    title: "Gutachter beauftragen",
    description: "Bei Schäden über 750€ empfiehlt sich ein unabhängiges Gutachten."
  },
  {
    step: "6",
    title: "Versicherung informieren",
    description: "Melden Sie den Schaden zeitnah Ihrer Versicherung."
  }
];

export const REVIEWS_PLACEHOLDER = [
  {
    id: 1,
    name: "Review Placeholder 1",
    rating: 5,
    text: "Platzhalter für echte Google/ProvenExpert Bewertung. Beispieltext: Sehr professioneller Service, schnelle Terminvergabe...",
    date: "2024",
    source: "Google"
  },
  {
    id: 2,
    name: "Review Placeholder 2",
    rating: 5,
    text: "Platzhalter für echte Google/ProvenExpert Bewertung. Beispieltext: Kompetente Beratung, alles super erklärt...",
    date: "2024",
    source: "ProvenExpert"
  },
  {
    id: 3,
    name: "Review Placeholder 3",
    rating: 5,
    text: "Platzhalter für echte Google/ProvenExpert Bewertung. Beispieltext: Unabhängige Bewertung, faire Abwicklung...",
    date: "2024",
    source: "Google"
  },
  {
    id: 4,
    name: "Review Placeholder 4",
    rating: 5,
    text: "Platzhalter für echte Google/ProvenExpert Bewertung. Beispieltext: Alles bestens gelaufen, kann ich nur empfehlen...",
    date: "2024",
    source: "ProvenExpert"
  }
];

export const FAQ_ITEMS = [
  {
    question: "Was kostet ein Unfallgutachten?",
    answer: "Bei unverschuldetem Unfall trägt in der Regel die gegnerische Haftpflichtversicherung die Kosten für das Gutachten. Sie haben als Geschädigter das Recht auf freie Gutachterwahl."
  },
  {
    question: "Wer bezahlt das Gutachten bei unverschuldetem Unfall?",
    answer: "Die Kosten werden üblicherweise von der Haftpflichtversicherung des Unfallverursachers übernommen. Als Geschädigter müssen Sie in der Regel nicht in Vorleistung gehen."
  },
  {
    question: "Wie schnell kann ich einen Termin bekommen?",
    answer: "Wir vereinbaren meist innerhalb von 30 Minuten einen Termin vor Ort. Die Begutachtung dauert etwa 30-60 Minuten. Das fertige Gutachten erhalten Sie in der Regel innerhalb von 2-3 Werktagen."
  },
  {
    question: "Kommt ihr wirklich bundesweit?",
    answer: "Ja, von unserem Hauptsitz in Rellingen aus sind wir deutschlandweit im Einsatz – egal ob Hamburg, NRW, Bayern oder Berlin."
  },
  {
    question: "Was ist der Unterschied zwischen Gutachten und Kostenvoranschlag?",
    answer: "Ein Kostenvoranschlag wird von Werkstätten erstellt und ist weniger detailliert. Ein Gutachten ist rechtlich belastbar und berücksichtigt auch Wertminderung, Nutzungsausfall und weitere Ansprüche. Ab ca. 750€ Schaden ist ein Gutachten empfehlenswert."
  },
  {
    question: "Brauche ich nach jedem Unfall ein Gutachten?",
    answer: "Bei kleineren Schäden unter 750€ reicht meist ein Kostenvoranschlag. Bei höheren Schäden oder wenn Sie alle Ansprüche geltend machen möchten, ist ein unabhängiges Gutachten die bessere Wahl."
  },
  {
    question: "Welche Fahrzeuge können begutachtet werden?",
    answer: "Wir erstellen Gutachten für PKW, Elektrofahrzeuge, LKW, Busse, Motorräder, Fahrräder und Boote."
  },
  {
    question: "Was wird im Gutachten dokumentiert?",
    answer: "Das Gutachten umfasst eine detaillierte Schadensdokumentation, Reparaturkostenberechnung, Wertminderung, Wiederbeschaffungswert und ggf. Nutzungsausfall."
  },
  {
    question: "Wie lange dauert die Erstellung des Gutachtens?",
    answer: "Nach der Begutachtung vor Ort erhalten Sie das fertige Gutachten innerhalb von 2-3 Werktagen. In Eilfällen ist auch eine Erstellung innerhalb von 24 Stunden möglich."
  },
  {
    question: "Kann ich den Gutachter frei wählen?",
    answer: "Ja! Sie haben als Geschädigter das gesetzliche Recht auf freie Gutachterwahl. Die Versicherung darf Ihnen keinen Gutachter vorschreiben."
  },
  {
    question: "Was ist Wertminderung und steht mir das zu?",
    answer: "Wertminderung ist der Wertverlust Ihres Fahrzeugs nach einem Unfall – auch nach Reparatur. Bei unverschuldetem Unfall haben Sie Anspruch darauf. Die Wertminderung wird im Gutachten berechnet und von der gegnerischen Versicherung bezahlt."
  },
  {
    question: "Was ist Nutzungsausfall?",
    answer: "Nutzungsausfall ist die Entschädigung dafür, dass Sie Ihr Fahrzeug während der Reparatur nicht nutzen können. Die Höhe richtet sich nach Fahrzeugklasse und Reparaturdauer. Auch dies zahlt die gegnerische Versicherung."
  },
  {
    question: "Muss ich das Gutachten selbst bezahlen?",
    answer: "Nein, bei unverschuldetem Unfall trägt die Haftpflichtversicherung des Unfallverursachers die Gutachterkosten. Sie müssen nicht in Vorleistung gehen."
  },
  {
    question: "Wie schnell muss ich nach dem Unfall handeln?",
    answer: "Melden Sie den Schaden Ihrer Versicherung innerhalb von 1 Woche. Den Gutachter sollten Sie idealerweise innerhalb von 24-48 Stunden beauftragen, solange der Schaden noch unverändert ist."
  },
  {
    question: "Was passiert bei Totalschaden?",
    answer: "Bei Totalschaden (Reparaturkosten höher als Wiederbeschaffungswert) ermittelt das Gutachten den Wiederbeschaffungswert und den Restwert. Die Differenz erhalten Sie von der Versicherung."
  }
];